<template>
  <div id="navBar" class="nav-position">
    <div class="container-fluid py-0">
      <div class="d-lg-block d-none">
        <div class="row">
          <!--          <span v-for="item in navItems"
                          :key="item.id">
                    <router-link v-if="isLoggedIn" :to="item.path"
                                 class="col-auto align-self-center">
                      {{ item.text }}
                    </router-link>
                      <div v-else class="col-auto align-self-center">
                        <span @click="showLoggedInDialog">{{ item.text }}</span>
                      </div>
                      </span>-->
          <div class="col-auto align-self-center">
            <router-link to="Home" class="pointer">خانه</router-link>
          </div>
          <div v-if="isLoggedIn" class="col-auto align-self-center">
            <router-link id="sendTicket" to="sendTicket" class="pointer">ارسال تیکت</router-link>
          </div>
          <div v-else class="col-auto align-self-center">
            <div id="sendTicket" @click="showLoggedInDialog" class="pointer">ارسال تیکت</div>
          </div>
          <div v-if="isLoggedIn" class="col-auto align-self-center">
            <router-link id="listTickets" to="listTickets" class="pointer">تیکت‌های من</router-link>
          </div>
          <div v-else class="col-auto align-self-center">
            <div id="listTickets" @click="showLoggedInDialog" class="pointer">تیکت‌های من</div>
          </div>
          <div v-if="isLoggedIn && $getUserData().role !== 5" class="col-auto align-self-center">
            <router-link to="listClientTicket" class="pointer">تیکت‌های مشتریان</router-link>
          </div>

          <div v-if="isLoggedIn && $getUserData().role !== 5" class="col-auto align-self-center">
            <router-link to="listNewTicket" class="pointer">تیکت‌های جدید</router-link>
          </div>

          <div class="col-auto align-self-center">
            <router-link id="knowledgeBaseClient" to="knowledgeBaseClient" class="pointer">پایگاه دانش</router-link>
          </div>
          <div class="col-auto align-self-center">
            <router-link to="aboutUs" class="pointer">درباره ما</router-link>
          </div>
          <div class="col-auto align-self-center">
            <router-link to="contactUs" class="pointer">تماس با ما</router-link>
          </div>
          <div class="col-auto align-self-center">
            <router-link to="TermsAndConditions" class="pointer">قوانین و مقررات</router-link>
          </div>
          <div v-if="isLoggedIn" class="col-auto align-self-center">
            <router-link to="suggestions" class="pointer">انتقادات و پیشنهادات</router-link>
          </div>
          <div v-else class="col-auto align-self-center">
            <div @click="showLoggedInDialog" class="pointer">انتقادات و پیشنهادات</div>
          </div>
          <div v-if="isLoggedIn" class="col-auto align-self-center">
            <router-link to="profile" class="pointer">پروفایل</router-link>
          </div>
          <div v-if="isLoggedIn && showAssignment" class="col-auto align-self-center">
            <router-link to="assignmentClient" class="pointer">کارها</router-link>
          </div>
          <!--          <div v-if="isLoggedIn" class="col-auto align-self-center">-->
          <!--            <div class="pointer" @click="signOutDialog">خروج</div>-->
          <!--          </div>-->
          <div class="col text-left">
            <span v-if="isLoggedIn" class="ml-2">
              <v-btn
                  outlined
                  elevation="0"
                  color="primary"
                  @click="showSignOutDialog = true">
                <span>خروج</span> <i class="fad fa-sign-out primary-text mr-1"></i>
              </v-btn>
            </span>
            <span v-else>
              <v-btn
                  class="ml-2"
                  outlined
                  elevation="0"
                  color="primary"
                  @click="signInDialog = true">
                <span>ورود</span> <i class="fad fa-sign-in primary-text mr-1"></i>
              </v-btn>
            </span>
            <!--            <span class="mx-2">
                          <v-btn
                              outlined
                              elevation="0"
                              color="primary"
                              @click="searchOverlay = true">
                            <span>جستجو</span> <i class="fad fa-search primary-text mr-1"></i>
                          </v-btn>
                        </span>-->
            <img :src="getImgUrl(src)" height="50"/>
          </div>
        </div>
      </div>
      <div class="d-lg-none d-block">
        <div class="row">
          <div class="col-6 text-right">
            <v-btn outlined icon color="primary" large class="rounded-lg" @click.stop="drawer = !drawer"><i
                class="fas fa-bars font16px"></i></v-btn>
          </div>
          <div class="col-6 text-left">
             <span v-if="isLoggedIn" class="ml-2">
              <v-btn icon large @click="showSignOutDialog = true" outlined color="primary">
                <i class="fas fa-sign-out font18px primary-text"></i>
              </v-btn>
            </span>
            <span v-else class="ml-2">
              <v-btn icon large @click="signInDialog = true" outlined color="primary">
                <i class="fas fa-sign-in font18px primary-text"></i>
              </v-btn>
            </span>
            <!--            <span class="mx-2">
                          <v-btn id="searchBtn" icon large @click="searchOverlay = true" outlined color="primary">
                            <i class="fas fa-search font18px primary-text"></i>
                          </v-btn>
                        </span>-->
            <img :src="getImgUrl(src)" height="47"/>
          </div>
        </div>
      </div>
    </div>
    <v-navigation-drawer
        :value="value"
        v-on:input="$emit('input', $event)"
        fixed
        temporary
        right
        v-model="drawer"
    >
      <v-list
          nav
          dense
      >
        <v-list-item-group
            v-model="group"
            class="mx-3"
        >
          <v-list-item class="my-2 d-flex justify-content-center">
            <v-list-item-title class="col-auto first-nav-item">
              <router-link :to="{ path: '/Home'}"><img :src="getImgUrl(src)" alt="لوگو تیکتینگ" height="80"
              ></router-link>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="my-2 ">
            <v-list-item-title class="black--text navDrawer-border pb-2 pr-2
">
              <i class="fas fa-home ml-2 primary-text"></i>
              <router-link :to="{ path: '/Home'}">خانه</router-link>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="my-2" v-if="isLoggedIn">
            <v-list-item-title class="black--text navDrawer-border pb-2 pr-2">
              <i class="fas fa-share-square ml-2 primary-text"></i>
              <router-link :to="{ path: 'sendTicket'}">ارسال تیکت</router-link>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="my-2" v-else>
            <v-list-item-title class="black--text navDrawer-border pb-2 pr-2">
              <i class="fas fa-share-square ml-2 primary-text"></i>
              <span @click="showLoggedInDialog">ارسال تیکت</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="my-2" v-if="isLoggedIn">
            <v-list-item-title class="black--text navDrawer-border pb-2 pr-2">
              <i class="fas fa-list-alt ml-2 primary-text"></i>
              <router-link :to="{ path: 'listTickets'}">تیکت ها</router-link>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="my-2" v-else>
            <v-list-item-title class="black--text navDrawer-border pb-2 pr-2">
              <i class="fas fa-list-alt ml-2 primary-text"></i>
              <span @click="showLoggedInDialog">تیکت ها</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="my-2">
            <v-list-item-title class="black--text navDrawer-border pb-2 pr-2">
              <i class="fas fa-database ml-2 primary-text"></i>
              <router-link :to="{ path: 'knowledgeBaseClient'}">پایگاه دانش</router-link>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="my-2">
            <v-list-item-title class="black--text navDrawer-border pb-2 pr-2">
              <i class="fas fa-eye ml-2 primary-text"></i>
              <router-link :to="{ path: 'aboutUs'}">درباره ما</router-link>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="my-2">
            <v-list-item-title class="black--text navDrawer-border pb-2 pr-2">
              <i class="fas fa-phone ml-2 primary-text"></i>
              <router-link :to="{ path: 'contactUs'}">تماس با ما</router-link>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="my-2">
            <v-list-item-title class="black--text navDrawer-border pb-2 pr-2">
              <i class="fas fa-balance-scale ml-2 primary-text"></i>
              <router-link :to="{ path: 'TermsAndConditions'}">قوانین و مقررات</router-link>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="isLoggedIn" class="my-2">
            <v-list-item-title class="black--text navDrawer-border pb-2 pr-2">
              <i class="fas fa-comment ml-2 primary-text"></i>
              <router-link :to="{ path: 'suggestions'}">انتقادات و پیشنهادات</router-link>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-else class="my-2">
            <v-list-item-title class="black--text navDrawer-border pb-2 pr-2">
              <i class="fas fa-cubes ml-2 primary-text"></i>
              <span @click="showLoggedInDialog">انتقادات و پیشنهادات</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="isLoggedIn" class="my-2">
            <v-list-item-title class="black--text navDrawer-border pb-2 pr-2">
              <i class="fas fa-cubes ml-2 primary-text"></i>
              <router-link :to="{ path: 'profile'}">پروفایل</router-link>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="isLoggedIn && showAssignment" class="my-2">
            <v-list-item-title class="black--text navDrawer-border pb-2 pr-2">
              <i class="fas fa-tasks ml-2 primary-text"></i>
              <router-link :to="{ path: 'assignmentClient'}">کارها</router-link>
            </v-list-item-title>
          </v-list-item>
          <!--          <v-list-item v-if="isLoggedIn" class="my-2">-->
          <!--            <v-list-item-title class="black&#45;&#45;text navDrawer-border pb-2 pr-2" @click="signOutDialog">-->
          <!--              <i class="fas fa-cubes ml-2 primary-text"></i><span>خروج</span>-->
          <!--            </v-list-item-title>-->
          <!--          </v-list-item>-->
          <!--          <v-list-item v-else class="my-2">-->
          <!--            <v-list-item-title @click="signInDialog = true" class="black&#45;&#45;text navDrawer-border pb-2 pr-2">-->
          <!--              <i class="fas fa-cubes ml-2 primary-text"></i><span>ورود</span>-->
          <!--            </v-list-item-title>-->
          <!--          </v-list-item>-->
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-dialog
        v-model="signInDialog"
        hide-overlay
        width="500">
      <v-card>
        <v-card-title class="primary-bg ">
          <div class="row justify-content-between no-gutters">
            <div class="col-auto font16px white--text">ورود</div>
            <div class="col-auto">
              <v-btn
                  color="primary"
                  icon
                  small
                  @click="signInDialog = false"
              >
                <!--                <i class="fas fa-times font-16 ml-1"></i>-->
                <v-icon small>fa-times</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-title>
        <v-card-text class="py-4">
          <v-form ref="form">
            <div class="my-4 text-right">موبایل</div>
            <v-text-field
                v-model="mobile"
                :rules="phoneNumberRules"
                class="input-border mb-1"
                dense
                flat
                placeholder="موبایل"
                solo
                type="number">
            </v-text-field>
            <!--            <div class="my-3 text-center">
                          <v-btn :disabled="mobile === null || mobile.length != 11"
                                 class="px-10"
                                 color="primary"
                                 elevation="0"
                                 rounded
                                 @click="getVerifyCode">
                            <span class="white&#45;&#45;text"> درخواست کد</span>
                          </v-btn>
                        </div>-->
            <div class="my-4 text-right">رمز عبور</div>
            <v-text-field
                v-model="password"
                :rules="[v => !!v || 'رمز عبور اجباری است']"
                class="input-border mb-1"
                dense
                type="password"
                flat
                placeholder="رمزعبور"
                solo>
            </v-text-field>
            <div class="my-3 text-center">
              <v-btn :disabled="password === null || password.length ===0" class="px-16" color="primary"
                     elevation="0"
                     rounded
                     @click="login">
                <span class="white--text">ورود</span>
              </v-btn>

              <!--              <router-link :to="{path:'Admin'}">
                              <v-btn class="px-16 mr-2 mt-sm-0 mt-2" color="primary" elevation="0" rounded>
                                <span class="white&#45;&#45;text">ورود پرسنل</span>
                              </v-btn>
                            </router-link>-->
            </div>
            <div class="mt-7"> رمز عبور خود را فراموش کرده اید؟ <span class="primary-text pointer"
                                                                      @click="getVerifyCode">درخواست کد</span></div>
          </v-form>
        </v-card-text>
        <!--            <v-card-actions class='row text-right'>
                      <div class="col-12 px-md-8">
                        رمزعبور خود را فراموش کرده اید؟
                        <span class="pointer text-primary" @click="forgetPasswordDialog =true">
                          بازیابی رمزعبور
                        </span>
                      </div>
                    </v-card-actions>-->
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showSignOutDialog"
        hide-overlay
        width="500">
      <v-card>
        <v-card-title class="primary-bg py-2">
          <div class="row no-gutters">
            <div class="col text-left">
              <v-btn
                  color="primary"
                  icon
                  small
                  @click="showSignOutDialog = false"
              >
                <v-icon small>fa-times</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-title>
        <v-card-text class="pb-2">
          <div class="text-center black--text mt-5">
            آیا میخواهید از حساب کاربری خود خارج شوید؟
          </div>
          <div class="text-center mt-4">
            <v-btn
                color="primary"
                rounded
                elevation="0"
                @click="signOut"
            >
              بله
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-overlay
        id="searchOverLay"
        :value="searchOverlay"
        :opacity="0.8"
    >
      <div class="text-left p-3">
        <v-btn
            light
            color="primary"
            icon
            @click="searchOverlay = false"
        >
          <v-icon>fa-times</v-icon>
        </v-btn>
      </div>
      <div id="searchFieldsBox" class="row h-75 align-items-center">
        <div class="col-sm-10 col-11 col-md-6 mx-auto">
          <div class="row ">
            <div class="col ">
              <v-text-field
                  v-model="searchKeyWord"
                  class="mb-1"
                  clearable
                  flat
                  light
                  solo
                  hide-details
                  placeholder="جستجو محتوا..."
                  @keydown="searchNews($event)"
              >
              </v-text-field>
            </div>
            <div class="col-auto align-self-center">
              <v-btn color="primary" icon large light>
                <!--                <i class="fas fa-search"></i>-->
                <v-icon>fa-search</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </div>


    </v-overlay>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        z-index="10000"
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
    <v-dialog
        v-model="showResultDialog"
        hide-overlay
        persistent
        width="530">
      <v-card class="text-center">
        <v-card-title class="justify-space-between primary-bg">
          <v-btn
              color="primary"
              icon
              small
              @click="showResultDialog = false">
            <v-icon small>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <div class="mb-0 black--text py-5">{{ dialogResult }}</div>
          <div>
            <v-btn v-if="showLoggedInBtn" color="primary" elevation="0" class="rounded-lg " @click="hideLoggedInDialog">
              ورود
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "navBar",
  props: {
    value: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    showAssignment: false,
    showLoggedInBtn: false,
    navItems: [
      {
        id: 1,
        text: 'خانه',
        path: "/Home"
      },
      {
        id: 2,
        text: 'ارسال تیکت',
        path: "/sendTicket"
      },
      {
        id: 3,
        text: 'تیکت‌ها',
        path: "/listTickets"
      },
      {
        id: 4,
        text: 'پایگاه دانش',
        path: "/knowledgeBaseClient"
      },
      {
        id: 5,
        text: 'درباره ما',
        path: "/aboutUs"
      },
      {
        id: 6,
        text: 'تماس با ما',
        path: "/contactUs"
      },
      {
        id: 7,
        text: 'قوانین و مقررات',
        path: "/TermsAndConditions"
      },
      {
        id: 8,
        text: 'انتقادات و پیشنهادات',
        path: "/suggestions"
      },
    ],
    signInDialog: false,
    showLoaderDialog: false,
    showResultDialog: false,
    drawer: false,
    showSignOutDialog: false,
    absolute: true,
    searchOverlay: false,
    mobile: null,
    username: null,
    dialogResult: null,
    searchKeyWord: null,
    deleteResult: null,
    phoneNumberRules: [
      v => !!v || 'شماره موبایل اجباری است',
      value => (value && value[0] === "0") || 'اولین رقم موبایل با عدد صفر شروع می شود ',
      value => (value && value.length === 11) || 'شماره موبایل 11 رقم است.',
    ],
    password: null,
    src: 'logo2.png',
    group: null,
    isLoggedIn: false,
  }),
  mounted() {
    this.silentLogin()
  },
  methods: {
    hideLoggedInDialog() {
      this.showResultDialog = false
      this.signInDialog = true
    },
    showLoggedInDialog() {
      this.showResultDialog = true
      this.dialogResult = 'برای ورود به این بخش ابتدا باید وارد سایت شوید.'
      this.showLoggedInBtn = true
    },
    getImgUrl(pic) {
      return require('../../assets/img/' + pic)
    },
    getVerifyCode() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("PhoneNumber", this.mobile);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/RecoveryOrRequestVerfiyMobile", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.dialogResult = result
            this.showResultDialog = true
          })
          .catch(error => console.log('error', error));
    },
    signOut() {
      this.showSignOutDialog = false
      this.isLoggedIn = false
      this.$setUserData('', '', '', '')
      this.silentLogin()
      this.$router.replace('/')
    },
    login() {
      this.showLoaderDialog = true
      let resStatus = null
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("PhoneNumber", this.mobile);
      urlencoded.append("VerifyCode", this.password);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/Login", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false
            if (resStatus !== 200) {
              this.dialogResult = result
              this.showResultDialog = true
            } else {
              let json = JSON.parse(result)
              this.token = 'Bearer ' + json.JwtToken
              this.$setUserData(this.mobile, this.password, this.token, json.Role, this.mobile);
              console.log(this.$setUserData(this.mobile, this.password, this.token, json.Role, this.mobile))
              if (json.Role === 3 || json.Role === 4 || json.Role === 6 || json.Role === 7 || json.Role === 8 || json.Role === 9) {
                this.showAssignment = true
              }
              if (json.Role === 1 || json.Role === 2) {
                this.$router.replace({path: '/Admin/Home'})
              } else {
                this.$router.replace({path: '/'})
              }
              this.signInDialog = false
              this.isLoggedIn = true
            }
          })
          .catch(error => console.log('error', error));

    },
    silentLogin() {

      let userData = this.$getUserData()
      if (userData.mobile !== '' && userData.activeCode !== '' && userData.mobile !== undefined && userData.activeCode !== null) {
        let resStatus = null
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        urlencoded.append("PhoneNumber", userData.mobile);
        urlencoded.append("VerifyCode", userData.activeCode);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "/Client/Login", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {
              this.showLoaderDialog = false
              if (resStatus === 200) {
                let json = JSON.parse(result)
                let token = 'Bearer ' + json.JwtToken
                this.$setUserData(userData.mobile, userData.activeCode, token, json.Role);
                this.isLoggedIn = true;
                if (json.Role === 3 || json.Role === 4 || json.Role === 6 || json.Role === 7 || json.Role === 8 || json.Role === 9) {
                  this.showAssignment = true
                }
                if (json.Role === 1 || json.Role === 2) {
                  this.$router.replace({path: '/Admin/Home'})
                }
              } else {
                this.isLoggedIn = false
              }
            })
            .catch(error => console.log('error', error));
      } else {
        this.isLoggedIn = false
      }


    },
  }
}
</script>

<style scoped>

</style>